import './App.scss';
import Header from '../Tools/Header/Header';
import Footer from '../Tools/Footer/Footer';
import Menu from '../Tools/Menu/Menu';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Offline, Online } from "react-detect-offline";
import Main from './Main';

// blogs images
import unlock from '../Images/unlock.png'
import reload from '../Images/reload.png'
import callbtn from '../Images/telephone.png'
import PopUp from '../Tools/PopUp/PopUp';

function App() {
  const [showMenu, setShowMenu] = useState(false)
  const [showPopUp, setShowPopUp] = useState(false)
  const [showVerify, setShowVerify] = useState(true)
  const [status, setStatus] = useState(true);
  const navigate = useNavigate()
  const location = useLocation()
  const [BookAnAppointment, setBookAnAppointment] = useState(true);

  const url = new URL(window.location.href);
  const [CitiesData, setCitiesData] = useState({});

  const [CitiePhone, setCitiePhone] = useState(url.searchParams.get('cp') ? url.searchParams.get('cp') : "213-699-2626");
  useEffect(() => {
    (async () => {

      // google //
      if (url.searchParams.get('spg') == "g") {
        const CitiesZipGoogle2 = (await import('./CitiesZipGoogle2.js')).default;
        if (CitiesZipGoogle2.find(a => a.ID == url.searchParams.get('cd'))) {
          const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${CitiesZipGoogle2.find(a => a.ID == url.searchParams.get('cd')).ZC}&key=AIzaSyC_XBMupYyuYy-f1TGdo32rsoHBhSMWPK0&language=en`, { method: 'GET', })
          const data = await res.json()
          // console.log(data.results[0])
          setCitiesData({
            "ID": CitiesData.ID,
            "City":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),
            "Full":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name + ', ' + data.results[0].address_components.find(a => a.types.find(a => a == 'administrative_area_level_1')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),

          })
        } else {
          const CitiesDataGoogle = (await import('./CitiesDataGoogle.js')).default;
          if (CitiesDataGoogle.find(a => a.ID == url.searchParams.get('cd'))) {
            setCitiesData(CitiesDataGoogle.find(a => a.ID == url.searchParams.get('cd')))
          } else {
            setCitiesData({})
          }
        }
      }

      // Microsoft //
      if (url.searchParams.get('spg') == "m") {
        const CitiesZipMS2 = (await import('./CitiesZipMS2.js')).default;
        if (CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd'))) {
          const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd')).ZC}&key=AIzaSyC_XBMupYyuYy-f1TGdo32rsoHBhSMWPK0&language=en`, { method: 'GET', })
          const data = await res.json()
          setCitiesData({
            "ID": CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd')).ID,
            "City":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),
            "Full":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name + ', ' + data.results[0].address_components.find(a => a.types.find(a => a == 'administrative_area_level_1')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),

          })
        } else {
          const CitiesDataMS = (await import('./CitiesDataMS.js')).default;
          if (CitiesDataMS.find(a => a.ID == url.searchParams.get('cd'))) {
            setCitiesData(CitiesDataMS.find(a => a.ID == url.searchParams.get('cd')))
          } else {
            setCitiesData({})
          }
        }
      }



      // const query = '?q={"Name": "Luanda"}'; // Example query
      // const res1 = await fetch(`https://bhocs-10ec.restdb.io/rest/cities${query}`, {
      //   method: 'GET',
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'apikey': '6714a668e2b4472fa2c2d036'
      //   }
      // });
      // const data1 = await res1.json()
      // console.log(data1)



      if (showVerify == true) {
        document.body.style.overflow = "hidden"
        document.body.style.overflow = "scroll"
      } else {
        document.body.style.overflow = "scroll"
      }
      setTimeout(() => {
        const checkpop = localStorage.getItem("showPopUp");
        if (checkpop) {
          setShowPopUp(false)
        } else {
          setShowPopUp(true)
        }
      }, 5000);
      window.addEventListener('online', () => setStatus(true))
      window.addEventListener('offline', () => setStatus(false))
    })();
  }, [showVerify, status]);

  // Blog
  const [Blogs, setBlogs] = useState([

  ]);
  // Faq
  const [FaqList, setFaqList] = useState([

    // locksmith Cleaning
    {
      question: "How often should I have my locksmith cleaned",
      questionPath: "How often should I have my locksmith cleaned",
      answer: "It's recommended to have your locksmith cleaned at least once a year, especially if you use your fireplace frequently. More frequent cleaning may be necessary if you burn a lot of wood or use your fireplace heavily.",
      category: "locksmith Cleaning",
      faqId: 1
    },

    {
      question: "What are the signs that my locksmith needs cleaning",
      questionPath: "What are the signs that my locksmith needs cleaning",
      answer: "Common signs include a strong odor from the fireplace, poor draft (smoke entering your home), and visible soot or creosote buildup inside the locksmith. If you notice these, it’s time for a cleaning.",
      category: "locksmith Cleaning",
      faqId: 2
    },

    {
      question: "Can I clean my locksmith myself",
      questionPath: "Can I clean my locksmith myself",
      answer: "While DIY locksmith cleaning kits are available, it’s best to hire a professional for a thorough and safe cleaning. Professionals have the tools and experience to remove creosote buildup effectively.",
      category: "locksmith Cleaning",
      faqId: 3
    },

    {
      question: "What is creosote, and why is it dangerous",
      questionPath: "What is creosote, and why is it dangerous",
      answer: "Creosote is a byproduct of burning wood that accumulates inside your locksmith. It’s highly flammable andnuse dangerous locksmith fires if not regularly cleaned.",
      category: "locksmith Cleaning",
      faqId: 4
    },

    {
      question: "Does locksmith cleaning prevent locksmith fires",
      questionPath: "Does locksmith cleaning prevent locksmith fires",
      answer: "Yes, regular locksmith cleaning significantly reduces the risk of locksmith fires by removing flammable creosote and blockages thatn lead to overheating.",
      category: "locksmith Cleaning",
      faqId: 5
    },

    // locksmith Inspection
    {
      question: "What is the purpose of a locksmith inspection",
      questionPath: "What is the purpose of a locksmith inspection",
      answer: "A locksmith inspection ensures that your locksmith is safe to use by identifying any structural damage, blockages, or buildup that could pose a fire hazard or affect performance.",
      category: "locksmith Inspection",
      faqId: 6
    },

    {
      question: "How often should I have a locksmith inspection",
      questionPath: "How often should I have a locksmith inspection",
      answer: "An annual locksmith inspection is recommended, especially if you use your fireplace regularly. Inspections are crucial for detecting issues before they become serious.",
      category: "locksmith Inspection",
      faqId: 7
    },

    {
      question: "What’s the difference between a Level 1, 2, and 3 locksmith inspection",
      questionPath: "What’s the difference between a Level 1, 2, and 3 locksmith inspection",
      answer: "Level 1 is a basic inspection, Level 2 includes a video scan of the locksmith, and Level 3 involves more invasive methods if serious issues are suspected, such as removing parts of the locksmith or surrounding structure.",
      category: "locksmith Inspection",
      faqId: 8
    },

    {
      question: "What should I do if my locksmith fails inspection",
      questionPath: "What should I do if my locksmith fails inspection",
      answer: "If your locksmith fails inspection, follow the recommendations provided by the inspector. This may include repairs, cleaning, or further investigation to ensure your locksmith is safe.",
      category: "locksmith Inspection",
      faqId: 9
    },

    {
      question: "Can a locksmith inspection detectrbon monoxide issues",
      questionPath: "Can a locksmith inspection detectrbon monoxide issues",
      answer: "Yes, a thorough inspectionn identify blockages or ventilation problems that could lead torbon monoxide buildup, ensuring your home’s air quality is safe.",
      category: "locksmith Inspection",
      faqId: 10
    },

    // locksmith Repair
    {
      question: "What are common locksmith repairs",
      questionPath: "What are common locksmith repairs",
      answer: "Common repairs include fixing cracks in the masonry, repairing or replacing the locksmith crown, relining the flue, and addressing water leaks or damageused by moisture.",
      category: "locksmith Repair",
      faqId: 11
    },

    {
      question: "How do I know if my locksmith needs repair",
      questionPath: "How do I know if my locksmith needs repair",
      answer: "Signs your locksmith needs repair include visible cracks, crumbling mortar, water leaks, a damaged locksmithp or crown, and poor draft (smoke not venting properly).",
      category: "locksmith Repair",
      faqId: 12
    },

    {
      question: "How much do locksmith repairs typically cost",
      questionPath: "How much do locksmith repairs typically cost",
      answer: "The cost of locksmith repairs varies depending on the extent of the damage. Minor repairs might cost a few hundred dollars, while major repairs, like relining,n run into the thousands.",
      category: "locksmith Repair",
      faqId: 13
    },

    {
      question: "How long does locksmith repair take",
      questionPath: "How long does locksmith repair take",
      answer: "The time required for locksmith repair depends on the scope of the work. Minor repairs might take a few hours, while more extensive work, like rebuilding,n take several days.",
      category: "locksmith Repair",
      faqId: 14
    },

    {
      question: "Can locksmith repairs be done year-round",
      questionPath: "Can locksmith repairs be done year-round",
      answer: "Yes, most locksmith repairsn be done year-round, but it’s ideal to schedule them during the warmer months to avoid potential issues with weather and fireplace use.",
      category: "locksmith Repair",
      faqId: 15
    },

    // 
    {
      question: "What does a  do",
      questionPath: "What does a  do",
      answer: "A  removes soot, creosote, and blockages from the inside of the locksmith, ensuring safe and efficient operation of your fireplace or stove.",
      category: "",
      faqId: 16
    },

    {
      question: "How often should I schedule a ",
      questionPath: "How often should I schedule a ",
      answer: "It’s recommended to have your locksmith swept annually, especially if you use your fireplace frequently. More frequent sweeps may be necessary depending on usage.",
      category: "",
      faqId: 17
    },

    {
      question: "What’s the difference between a  and a locksmith cleaning",
      questionPath: "What’s the difference between a  and a locksmith cleaning",
      answer: "The terms are often used interchangeably, but generally, a  refers to the professional service, while locksmith cleaning refers to the actual process of removing soot and debris.",
      category: "",
      faqId: 18
    },

    {
      question: "Hown I prepare for a  visit",
      questionPath: "Hown I prepare for a  visit",
      answer: "Before the sweep arrives, clear the area around your fireplace, cover furniture to protect from dust, and avoid using the fireplace for at least 24 hours prior.",
      category: "",
      faqId: 19
    },

    {
      question: "Is a  messy",
      questionPath: "Is a  messy",
      answer: "Professional s take precautions to minimize mess, using drop cloths and vacuums to keep your home clean during the process.",
      category: "",
      faqId: 20
    },

    // locksmith Liner Installation
    {
      question: "What is a locksmith liner",
      questionPath: "What is a locksmith liner",
      answer: "A locksmith liner is a protective barrier inside the locksmith that helps contain the combustion byproducts, protects the locksmith walls from heat and corrosion, and improves draft.",
      category: "locksmith Liner Installation",
      faqId: 21
    },

    {
      question: "Why might I need a new locksmith liner",
      questionPath: "Why might I need a new locksmith liner",
      answer: "You may need a new liner if your current liner is damaged, missing, or incompatible with your heating appliance. A new linern also improve safety and efficiency.",
      category: "locksmith Liner Installation",
      faqId: 22
    },

    {
      question: "How long does locksmith liner installation take",
      questionPath: "How long does locksmith liner installation take",
      answer: "The installation of a locksmith liner typically takes a few hours to a full day, depending on the complexity of the locksmith and the type of liner being installed.",
      category: "locksmith Liner Installation",
      faqId: 23
    },

    {
      question: "What types of locksmith liners are available",
      questionPath: "What types of locksmith liners are available",
      answer: "Common types of locksmith liners include clay tile, metal (stainless steel or aluminum), andst-in-place liners, each with its own benefits depending on your locksmith’s needs.",
      category: "locksmith Liner Installation",
      faqId: 24
    },

    {
      question: "How much does locksmith liner installation cost",
      questionPath: "How much does locksmith liner installation cost",
      answer: "The cost of installing a locksmith liner varies based on the material and the complexity of the installation, typically ranging from $1,000 to $3,000.",
      category: "locksmith Liner Installation",
      faqId: 25
    },

    // locksmith Crown Repair
    {
      question: "What is a locksmith crown",
      questionPath: "What is a locksmith crown",
      answer: "A locksmith crown is the concrete slab or masonryp that covers the top of your locksmith, protecting it from water damage by directing rain and snow away from the locksmith structure.",
      category: "locksmith Crown Repair",
      faqId: 26,
    },

    {
      question: "How do I know if my locksmith crown needs repair",
      questionPath: "How do I know if my locksmith crown needs repair",
      answer: "Signs that your locksmith crown needs repair include visible cracks, crumbling concrete, water leaks, and moss or vegetation growth on the crown.",
      category: "locksmith Crown Repair",
      faqId: 27,
    },

    {
      question: "What happens if I don’t repair a damaged locksmith crown",
      questionPath: "What happens if I don’t repair a damaged locksmith crown",
      answer: "Neglecting a damaged crownn lead to serious water damage, including leaks, locksmith deterioration, and even structural damage to your home.",
      category: "locksmith Crown Repair",
      faqId: 28,
    },

    {
      question: "How long does locksmith crown repair take",
      questionPath: "How long does locksmith crown repair take",
      answer: "locksmith crown repair usually takes a few hours to a day, depending on the extent of the damage and whether a full replacement is needed.",
      category: "locksmith Crown Repair",
      faqId: 29,
    },

    {
      question: "Can a locksmith crown be replaced",
      questionPath: "Can a locksmith crown be replaced",
      answer: "Yes, if the crown is severely damaged or deteriorated, a full replacement may be necessary to ensure proper protection for your locksmith.",
      category: "locksmith Crown Repair",
      faqId: 30,
    },

    // locksmith Draft Issues
    {
      question: "Whatuses locksmith draft issues",
      questionPath: "Whatuses locksmith draft issues",
      answer: "Commonuses of locksmith draft issues include blockages, improper locksmith height, air pressure differences, and a lack of proper ventilation or locksmithp.",
      category: "locksmith Draft Issues",
      faqId: 31,
    },

    {
      question: "Hown I tell if I have a locksmith draft problem",
      questionPath: "Hown I tell if I have a locksmith draft problem",
      answer: "Signs of a draft problem include smoke entering your home instead of exiting through the locksmith, a fireplace that doesn’t stay lit, and strong odors from the fireplace.",
      category: "locksmith Draft Issues",
      faqId: 32,
    },

    {
      question: "Can a locksmithp help with draft issues",
      questionPath: "Can a locksmithp help with draft issues",
      answer: "Yes, installing a locksmithpn help with draft issues by preventing downdrafts and keeping debris and animals out of the locksmith.",
      category: "locksmith Draft Issues",
      faqId: 33,
    },

    {
      question: "Hown locksmith draft issues be fixed",
      questionPath: "Hown locksmith draft issues be fixed",
      answer: "Fixing draft issues may involve cleaning blockages, adjusting the locksmith height, improving ventilation, or installing a draft-inducing device or locksmithp.",
      category: "locksmith Draft Issues",
      faqId: 34,
    },

    {
      question: "Are draft issues more common in older homes",
      questionPath: "Are draft issues more common in older homes",
      answer: "Draft issuesn occur in any home, but older homes may be more susceptible due to outdated locksmith designs, wear and tear, or settling of the structure.",
      category: "locksmith Draft Issues",
      faqId: 35,
    },
  ]);
  // WebSitePages
  const [WebSitePages, setWebSitePages] = useState([
    // Resources
    {
      Name: "Home Page",
      Path: "/",
      category: "Resources"
    },
    {
      Name: "Apply Now",
      Path: "/apply",
      category: "Resources"
    },
    {
      Name: "Contact",
      Path: "/contact",
      category: "Resources"
    },
    {
      Name: "Blog",
      Path: "/blog",
      category: "Resources"
    },
    {
      Name: "Faq",
      Path: "/faq",
      category: "Resources"
    },
    // Aboout Us
    {
      Name: "Success Stories",
      Path: "/successstories",
      category: "About Us"
    },
    {
      Name: "Links",
      Path: "/links",
      category: "About Us"
    },

    // Servcies
    {
      Name: "Business Line of Credit",
      Path: "/business-line-of-credit",
      category: "Sulotion"
    },
    {
      Name: "Business Term Loan",
      Path: "/long-term-loan",
      category: "Sulotion"
    },
    {
      Name: "Small Business Loan",
      Path: "/sba-loan",
      category: "Sulotion"
    },
    {
      Name: "Same Day Funding",
      Path: "/same-day-funding",
      category: "Sulotion"
    },
    {
      Name: "Privacy Policy",
      Path: "/privacypolicy",
      category: "About"
    },
    {
      Name: "Terms Conditions",
      Path: "/termsconditions",
      category: "About"
    },
    {
      Name: "Site Map",
      Path: "/sitemap",
      category: "About"
    },
  ]);

  const navigateTo = (page) => {
    navigate('/' + page)
    setShowMenu(false)

  }

  return (
    <div className="App" style={false ? { "document.html.style.overflow": "hidden" } : null}>

      <Offline>
        <div className="OfflineApp">
          <h1><img src={unlock} alt=" | locksmith Repair | locksmith Services | locksmith Inspection" /><span>Internet Connection Is Not Stable.</span>Your network seems to be disconnected. Please check your internet connection.</h1>
          <img onClick={() => window.location.reload()} className='OfflineAppClose' src={reload} alt=" | locksmith Repair | locksmith Services | locksmith Inspection" />
        </div>
      </Offline>


      {/* Menu */}
      {showMenu ? <Menu CitiePhone={CitiePhone} WebSitePages={WebSitePages} navigateTo={navigateTo} setShowMenu={setShowMenu} /> : null}
      {/* Header */}
      {location.pathname == "/apply" || location.pathname == "/thankscontact" || location.pathname == "/thanks" || location.pathname.match("/portal/:*") ? null : <Header CitiePhone={CitiePhone} WebSitePages={WebSitePages} showMenu={showMenu} navigateTo={navigateTo} setShowMenu={setShowMenu} />}
      {/* Main */}
      <Main CitiePhone={CitiePhone} CitiesData={CitiesData} FaqList={FaqList} WebSitePages={WebSitePages} Blogs={Blogs} navigateTo={navigateTo} />
      {/* Footer */}
      {/* {location.pathname == "/local" || location.pathname == "/thanks" || location.pathname == "/thankscontact" || location.pathname.match("/portal/:*") ? null : <Footer CitiePhone={CitiePhone} WebSitePages={WebSitePages} navigateTo={navigateTo} />} */}

      {/* oNLINE */}

      <div className="AppCall">
        <div className="AppCallbox">
          <a className='callButtonMainApp' href={`tel:${CitiePhone}`}> <img src={require(`../Images/telephone.png`)} alt="" />CLICK TO CALL!</a>
          <a className='bookButtonMainApp' href={`tel:${CitiePhone}`}>Get Help Now! Call us at <span>{CitiePhone}</span></a>
        </div>
      </div>

    </div>
  );
}

export default App;
